<template>
  <div :class="classnames">
    <button @click="handleClick"><img src="../../assets/images/icon-back.svg"/>Go Back</button>
  </div>
</template>

<script>
  import VueButton from '@/components/VueButton'

  import SvgIconCloseCircle from '@/svgs/SvgIconCloseCircle'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'toolbar-back-button'

  export default {
    name: 'ToolbarBackButton',
    components: {
      'svg-icon-close-circle': SvgIconCloseCircle,
      'vue-button': VueButton
    },
    mixins: [ bem ],
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handleClick () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ToolbarBackButton.vue